import React from "react";
import ReactDOM from "react-dom";
 
import {App} from './App';
import * as serviceWorker from './serviceWorker';
import { StoreProvider } from './Store';
import { Provider } from 'react-redux';

import { store } from './_helpers';

ReactDOM.render(
	<Provider store={store}>
		  
    <App />
  ,
	</Provider>
	, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
// import React from 'react';
// import { render } from 'react-dom';
// import { Provider } from 'react-redux';

// import { store } from './_helpers';
// import { App } from './App';

// // setup fake backend
// import { configureFakeBackend } from './_helpers';
// configureFakeBackend();

// render(
//     <Provider store={store}>
//         <App />
//     </Provider>,
//     document.getElementById('app')
// );